/* eslint-disable */
import React, { useCallback, useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import WordSearch from './WordSearch';
import useDocumentTitle from '../../../components/useDocumentTitle';

export default function WorthHearing() {
  const navigate = useNavigate();
  useDocumentTitle(`May Newsletter | Pastor Chris Digital Library`);

  const [titles, setTitles] = useState([]);
  const [loadingTitles, setLoadingTitles] = useState(true);

  const testimonies = useMemo(
    () => [
      {
        img: 'https://d1zx0zj5kmre28.cloudfront.net/images/covers/Success_in_Life.jpg',
        title: 'Success in Life',
        href: 'https://d1ent1.loveworldcloud.com/~pcdl//testimonies/anna_schmitt_testimony.mp4',
      },
      {
        img: 'https://d1zx0zj5kmre28.cloudfront.net/images/covers/Power_For_Change.jpg',
        title: 'Power for Change',
        href: 'https://d1ent1.loveworldcloud.com/~pcdl//testimonies/fiona_mercy_testimony.mp4',
      },
      {
        img: 'https://d1zx0zj5kmre28.cloudfront.net/images/covers/Success_in_Business.jpg',
        title: 'Success in Business',
        href: 'https://d1ent1.loveworldcloud.com/~pcdl//testimonies/sister_nkechi_testimony.mp4',
      },
    ],
    [],
  );

  useEffect(() => {
    const controller = new AbortController();

    const fetchMessages = async () => {
      try {
        setLoadingTitles(true);

        const res = await fetch(
          'https://nmt.loveworldapis.com/api/pcdl/lists/messages',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: 'newreleases' }),
            signal: controller.signal,
          },
        );

        const data = await res.json();
        const list = Array.isArray(data?.data) ? data.data : [];

        // const filtered = list.filter((item) => allowedTitleSet.has(item.title));
        setTitles(list.slice(0, 5));
      } catch (err) {
        if (err.name !== 'AbortError') {
          console.error(err);
        }
      } finally {
        setLoadingTitles(false);
      }
    };

    fetchMessages();

    return () => controller.abort();
  }, []);

  const monthlySelection = useMemo(
    () => [
      { id: 1, title: 'Communion Service May', url: '/#' },
      { id: 2, title: 'Baptisms, Communion and the Church', url: 'https://pcdl.co/watch/yQOsMLJfs24/baptisms-communion-and-the-church' },
      { id: 3, title: 'Our Righteous Cause', url: 'https://pcdl.co/watch/JBRzGv6_RJM/our-righteous-cause' },
    ],
    [],
  );

  const quizQuestions = useMemo(
    () => [
      'What is the theme scripture for the month of May?',
      'What are the 3 key areas the Man of God said we will advance in?',
      'What was the word of the month for February, March, April and May?',
    ],
    [],
  );

  const advancementWords = useMemo(
    () => [
      'Forward',
      'Ahead',
      'Progression',
      'Boom',
      'Advance',
      'Promotion',
      'Furtherance',
    ],
    [],
  );

  const newMessages = useMemo(
    () => ['Wailing Women', 'Jesus is Adonai', '3 Elements of Worship'],
    [],
  );

  const handleBrowseNewTitles = useCallback(() => {
    navigate('./NewTitles');
  }, [navigate]);

  return (
    <div className="min-h-screen bg-slate-900 text-white">
      {/* Hero */}
      <section
        className="relative min-h-[520px] bg-cover bg-center flex items-center"
        style={{
          backgroundImage:
            'linear-gradient(rgba(0,0,0,0.45), rgba(0,0,0,0.65)), url("./P1.jpg")',
        }}
      >
        <div className="mx-auto w-full max-w-6xl px-5 sm:px-8 py-20 sm:text-left">
          <div className="max-w-xl">
            <p className="mb-4 text-sm uppercase tracking-[0.35em] text-[#FFCC00]">
              May Edition
            </p>

            <h1 className="text-4xl sm:text-5xl md:text-6xl font-bold leading-[0.95] tracking-[-2px]">
              <span className="italic font-light">Titles</span>
              <br />
              <span className="text-[#FFCC00] italic font-light">Worth</span>
              <br />
              <span>Hearing</span>
            </h1>

            <p className="mt-6 max-w-md text-base sm:text-lg text-white/85">
              Explore fresh teaching titles, quizzes, character studies and word
              activities for the month of Advancement.
            </p>
          </div>
        </div>
      </section>

      {/* Featured Titles */}
      <section className="bg-black py-14">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between sm:text-left">
            <div>
              <p className="text-sm uppercase tracking-[0.3em] text-[#E71D72]">
                New Releases
              </p>
              <h2 className="mt-2 text-2xl sm:text-3xl font-bold">
                Messages Worth Hearing
              </h2>
            </div>

            {/* <button
              type="button"
              className="w-fit rounded-md bg-[#E71D72] px-5 py-2 text-sm font-bold text-white transition hover:opacity-90"
              onClick={handleBrowseNewTitles}
            >
              Browse New Titles
            </button> */}
          </div>

          {loadingTitles ? (
            <p className="text-white/70">Loading titles...</p>
          ) : titles.length > 0 ? (
            <div className="grid grid-cols-2 gap-5 sm:grid-cols-3 lg:grid-cols-5">
              {titles.map((item) => (
                <a
                  href={`/watch/${item.id}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  key={item.id}
                  className="group rounded-xl bg-white/5 p-3 transition hover:bg-white/10"
                >
                  <img
                    src={item.thumbnail}
                    alt={item.title}
                    loading="lazy"
                    className="aspect-square w-full rounded-lg object-cover"
                  />
                  <h3 className="mt-3 text-sm font-semibold leading-tight text-white group-hover:text-[#FFCC00]">
                    {item.title}
                  </h3>
                </a>
              ))}
            </div>
          ) : (
            <div className="rounded-xl bg-white/5 p-6 text-white/75">
              No matching titles found yet.
            </div>
          )}
        </div>
      </section>

      {/* Monthly Selection */}
      <section
        className="bg-cover bg-center py-16"
        style={{
          backgroundImage:
            'linear-gradient(rgba(0,0,0,0.72), rgba(0,0,0,0.82)), url("./th1.png")',
        }}
      >
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          <div className="max-w-2xl mx-auto">
            <h2 className="text-3xl sm:text-4xl font-bold leading-tight tracking-[-1px]">
              <span className="italic font-light">This</span>
              <br />
              <span className="text-[#FFCC00] italic font-light">Month’s</span>
              <br />
              Selection
            </h2>

            <h3 className="mt-5 text-xl font-bold">
              Recommended Messages for the Word of the Month
            </h3>

            <p className="mt-3 text-white/80">
              Build yourself up daily in the Word as you enjoy carefully
              selected titles aligned with the message of the month from the Man
              of God, Pastor Chris.
            </p>
          </div>

          <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {monthlySelection.map((item) => (
              <a
                key={item.id}
                href={item.url}
                target="_blank"
                rel="noopener noreferrer"
                className="rounded-2xl bg-white/10 p-6 text-left transition hover:-translate-y-1 hover:bg-white/15"
              >
                <div className="mb-8 flex h-12 w-12 items-center justify-center rounded-full bg-[#FFCC00] text-lg font-black text-black">
                  {item.id}
                </div>
                <h3 className="text-xl font-bold">{item.title}</h3>
              </a>
            ))}
          </div>

          {/* <button
            type="button"
            className="mt-8 rounded-md bg-[#E71D72] px-5 py-2 text-sm font-bold text-white transition hover:opacity-90"
          >
            This Month’s Messages
          </button> */}
        </div>
      </section>

      {/* Testimonies */}
      <section className="bg-slate-950 py-16">
        <div className="mx-auto max-w-6xl px-5 sm:px-8">
          <div className="max-w-2xl mx-auto text-center">
            <h2 className="text-3xl sm:text-4xl font-bold leading-tight">
              <span className="italic font-light">Testimonies</span>
              <br />
              <span className="text-[#E71D72] italic font-light">Worth</span>
              <br />
              Hearing
            </h2>

            <p className="mt-5 text-white/80">
              Be inspired as you listen to real life testimonies of the impact
              of the messages on the Pastor Chris Digital Library.
            </p>
          </div>

          <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
            {testimonies.map((item) => (
              <a
                key={item.title}
                href={item.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group overflow-hidden rounded-xl bg-white/5 shadow-lg transition hover:-translate-y-1 hover:bg-white/10"
              >
                <img
                  src={item.img}
                  alt={item.title}
                  loading="lazy"
                  className="aspect-square w-full object-cover transition duration-300 group-hover:scale-105"
                />
              </a>
            ))}
          </div>

          {/* <p className="mt-8 max-w-2xl text-white/80 mx-auto text-center">
            Share your testimony with us. How has the Man of God, Pastor Chris,
            impacted your life? Upload and share your personal testimony.
          </p>

          <div className="mt-5 flex justify-center">
            <button
              type="button"
              className="rounded-md bg-[#E71D72] px-5 py-2 text-sm font-bold text-white transition hover:opacity-90"
            >
              Upload Your Testimony
            </button>
          </div> */}
        </div>
      </section>

      {/* Quizzes & Games */}
      <main>
        <section className="bg-slate-800 py-16">
          <div className="mx-auto max-w-6xl px-5 sm:px-8">
            <h2 className="text-3xl sm:text-4xl font-bold leading-tight">
              <span className="italic text-[#FFCC00]">Quizzes &</span>
              <br />
              Games
            </h2>

            <div className="mt-10 grid gap-8 lg:grid-cols-[1fr_360px]">
              <div className="rounded-2xl bg-white/5 p-5 sm:p-8 text-left">
                <div className="mt-8">
                  <h3 className="text-2xl font-bold">
                    Quiz - The Month of Advancement
                  </h3>

                  <div className="mt-5 space-y-3">
                    {quizQuestions.map((question, index) => (
                      <p key={question} className="text-white/85">
                        <span className="font-bold text-[#FFCC00]">
                          Q{index + 1}.
                        </span>{' '}
                        {question}
                      </p>
                    ))}
                  </div>
                </div>

                <div className="mt-8 grid gap-4 md:grid-cols-3 text-left">
                  <div className="rounded-2xl bg-[#2FA4A9] p-6">
                    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white text-xl font-bold text-[#2FA4A9]">
                      1
                    </div>
                    <h3 className="mb-3 font-bold">Messages for the Month</h3>
                    {monthlySelection.map((item) => (
                      <p key={item.id}>{item.title}</p>
                    ))}
                  </div>

                  <div className="rounded-2xl bg-[#4FB6A8] p-6">
                    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white text-xl font-bold text-[#4FB6A8]">
                      2
                    </div>
                    <h3 className="mb-3 font-bold">Theme Scripture</h3>
                    <p>Exodus 14:15</p>
                  </div>

                  <div className="rounded-2xl bg-[#8BC34A] p-6">
                    <div className="mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-white text-xl font-bold text-[#8BC34A]">
                      3
                    </div>
                    <h3 className="mb-3 font-bold">
                      What Does Advancement Mean?
                    </h3>
                    <p>{advancementWords.join(', ')}</p>
                  </div>
                </div>
              </div>

              <aside className="rounded-2xl bg-white p-6 text-slate-900">
                <h3 className="text-2xl font-black">Character Profile</h3>
                <p className="mt-1 text-sm font-bold uppercase tracking-[0.2em] text-[#E71D72]">
                  Moses
                </p>

                <img
                  src="https://d1zx0zj5kmre28.cloudfront.net/images/newsletter/moses-profile.jpg"
                  alt="Moses"
                  loading="lazy"
                  className="mt-5 aspect-video w-full rounded-xl object-cover bg-slate-200"
                />

                <p className="mt-5 text-sm leading-7 text-slate-700">
                  Moses is a key figure in Christianity, known for his role as a
                  prophet, lawgiver, and leader in the Bible. God used him as a
                  liberator to free the Israelites from slavery in Egypt and
                  lead them to the Promised Land. Moses served as a leader,
                  legislator, and prophet who received the Ten Commandments from
                  God. He was also the author of the first five books of the
                  Bible. His story highlights God's goodness and power in a
                  challenging journey of faith and miracles.
                </p>
              </aside>
            </div>
          </div>
        </section>

        {/* New Messages / Word Search / Answers */}
        <section className="bg-slate-800 pb-16">
          <div className="mx-auto max-w-6xl px-5 sm:px-8">
            <div className="grid gap-8 lg:grid-cols-2">
              <div className="rounded-2xl bg-white p-6 text-slate-900">
                <h3 className="text-2xl font-black">New Messages Released</h3>

                <div className="mt-5 space-y-3">
                  {newMessages.map((message, index) => (
                    <p key={message}>
                      <span className="font-bold">{index + 1}.</span> {message}
                    </p>
                  ))}
                </div>

                <div className="mt-8 rounded-2xl bg-slate-100 p-5">
                  <h4 className="font-black">Word Search Words</h4>
                  <div className="mt-4 flex flex-wrap gap-2">
                    {advancementWords.map((word) => (
                      <span
                        key={word}
                        className="rounded-full bg-slate-900 px-3 py-1 text-sm font-bold text-white"
                      >
                        {word}
                      </span>
                    ))}
                  </div>
                </div>
              </div>

              <div className="rounded-2xl bg-white p-6 text-slate-900">
                <WordSearch />
              </div>
            </div>

            <div className="mt-8 grid gap-8 lg:grid-cols-[1fr_300px]">
              <div className="rounded-2xl bg-white p-6 text-slate-900">
                <h3 className="text-2xl font-black">
                  Answers to the Questions
                </h3>

                <div className="mt-5 space-y-4 text-sm sm:text-base text-left">
                  <p>
                    <span className="font-bold">Q1:</span> Exodus 14:15
                  </p>

                  <p>
                    <span className="font-bold">Q2:</span> Advance in the
                    kingdom, advance in all that He asked us to do, and advance
                    in all that concerns us.
                  </p>

                  <p>
                    <span className="font-bold">Q3:</span> February - Throne
                    Room, March - Focus, April - Prophecy, May - Advancement.
                  </p>
                </div>
              </div>

              <img
                src="/images/banners/hs-1.jpg"
                alt="Banner"
                loading="lazy"
                className="h-full min-h-[260px] w-full rounded-2xl object-cover"
              />
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
